// extracted by mini-css-extract-plugin
export default {"mainOuter":"styles_mainOuter__4ilky","main":"styles_main__fD3Tw","content":"styles_content__7qfj7"};